import React from 'react';

export const BookMockup = ({ className = '' }) => {
  const coverUrl = "https://media-manager-c.questera.ai/greta-media/1020052fea4646cda0b6350a92290b5d8aad67ab848ee0e26ed330cb10bc0462b7cba33c940299c4772469600661d72c/images/aW1hZ2UvanBlZw==/efd9947c54ec63bdf05d179ef7cbb3e4.jpg";

  return (
    <div className={`relative w-64 h-96 md:w-80 md:h-[480px] mx-auto ${className}`} style={{ perspective: '1000px' }}>
      {/* 3D Book Container */}
      <div 
        className="absolute inset-0 bg-navy shadow-book rounded-r-xl border-l-[10px] border-[#060f1c] overflow-hidden"
        style={{ transform: 'rotateY(-15deg) rotateX(5deg)', transformStyle: 'preserve-3d' }}
      >
        {/* Real Book Cover Image */}
        <img 
          src={coverUrl} 
          alt="Der Dividenden-Investor Buchcover" 
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        {/* Lighting Glare overlay for 3D realism */}
        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent pointer-events-none"></div>
      </div>
    </div>
  );
};